export const INTERACTION_DOWNLOAD_LIMIT = 5000;
